import IntroductionWithImage from "../components/IntroductionWithImage";
import MainImageCarousel from "../components/MainImageCarousel";
import CardCarousalContainer from "../components/CardCarousalContainer";
import StickyNavAndFooter from "./layout/StickyNavAndFooter";
import { mainPageIntroduction, missionCards, visionCards } from "../data/data";
import aLetterToSelf from '../resources/images/a-letter-to-self.png'
import { Box, Button, Card, CardBody } from "@chakra-ui/react";
import { primaryColor, secondaryColorTwo } from "../config";
import RandomQuestionField from "../components/RandomQuestionField";
import { useEffect, useState } from "react";
import elephant_in_the_room from '../resources/images/elephant_in_the_room.png'



export default function Home() {

    const [currentImage, setCurrentImage] = useState(aLetterToSelf);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setCurrentImage(currentImage === aLetterToSelf ? elephant_in_the_room : aLetterToSelf);
        }, 5000);

        return () => clearTimeout(timeout);
    }, [currentImage]);

    return (
        <StickyNavAndFooter>
            {/* <MainImageCarousel /> */}
            <RandomQuestionField />
            <Card borderRadius={20}>
                <CardBody  >
                    <IntroductionWithImage img={currentImage} id={"main-introduction"}>
                        {mainPageIntroduction}
                        <br />
                        <Box textAlign={"right"}>
                            <Button bg={primaryColor} color={"white"}
                                as={'a'}
                                href={"/activities"}
                                _hover={{
                                    backgroundColor: secondaryColorTwo,
                                }}>Take a Step!</Button>
                        </Box>
                    </IntroductionWithImage>
                </CardBody>
            </Card>

            {/* <IEngg id={"ie-introduction"} /> */}
            <br />
            <Box id={"vision"}>
                <CardCarousalContainer cards={visionCards} containerTitle={"Vision"} />
            </Box>
            <br />
            <br />
            <Box id='mission'>
                <CardCarousalContainer cards={missionCards} containerTitle="Mission" />
            </Box>
        </StickyNavAndFooter>
    )
}